import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 4h14a2 2 0 0 1 2 2v6a9 9 0 0 1 -18 0v-6a2 2 0 0 1 2 -2","key":"svg-0"}],["path",{"d":"M8 11l4 4l4 -4","key":"svg-1"}]]

/**
 * IconBrandPocket
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtcG9ja2V0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDRoMTRhMiAyIDAgMCAxIDIgMnY2YTkgOSAwIDAgMSAtMTggMHYtNmEyIDIgMCAwIDEgMiAtMiIgLz4KICA8cGF0aCBkPSJNOCAxMWw0IDRsNCAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-pocket
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandPocket = createReactComponent('outline', 'brand-pocket', 'BrandPocket', __iconNode);

export default IconBrandPocket;